'use client'
import { useLanguage } from '@/lib/context/LanguageContext'
import { FadeInUp } from '@/components/ui/FadeInUp'
import { sectionNum } from '@/lib/utils'

export default function SectionHeader({ num, label }: { num: string; label: string }) {
  const { lang } = useLanguage()
  return (
    <FadeInUp>
      <div className="flex items-center gap-3 mb-10 md:mb-20">
        <span className="text-xs font-semibold uppercase tracking-[0.18em] text-primary">
          {sectionNum(num, lang)}
        </span>
        <span className="w-8 h-px bg-ink/10" />
        <span className="text-xs font-semibold uppercase tracking-[0.18em] text-muted">
          {label}
        </span>
      </div>
    </FadeInUp>
  )
}
